import {DIALOGS_EVENTS} from './dialogsEvents';

/**
 * @about Closes the last opened dialog by openDialog().
 */
export function closeCurrentDialog() {
  window.dispatchEvent(new CustomEvent(DIALOGS_EVENTS.closeCurrent));
}
